import {
  Step1DetectOnPeriodsResults,
  Step2ValidateCycleResults,
  Step3ExtractFeaturesResults,
  Step4PredictResults,
} from "@/chargeDetection/results"
import type {
  Step1DetectOnPeriodsResponse,
  Step2ValidateCycleResponse,
  Step3ExtractFeaturesResponse,
  Step4PredictResponse,
} from "@/chargeDetection/types"
import { StepConfig } from "@/chargeDetection/StepPipeline";

// Type-safe helper to create step configs
export function createStepConfig<TResponse>(
  config: StepConfig<TResponse>
): StepConfig<TResponse> {
  return config
}

export const createDetectionStepConfigs = (
  api: ReturnType<typeof import("@/chargeDetection/api").useChargeDetection>
) => [
  createStepConfig<Step1DetectOnPeriodsResponse>({
    id: 1,
    title: 'Detecting Cycles',
    ResultComponent: Step1DetectOnPeriodsResults,
    mutation: api.step1DetectOnPeriods,
    fallbackMutation: api.step1FallbackDetectOnPeriod,
  }),
  createStepConfig<Step2ValidateCycleResponse>({
    id: 2,
    title: 'Validating Cycle',
    ResultComponent: Step2ValidateCycleResults,
    mutation: api.step2ValidateCycle,
  }),
  createStepConfig<Step3ExtractFeaturesResponse>({
    id: 3,
    title: 'Extracting Features',
    ResultComponent: Step3ExtractFeaturesResults,
    mutation: api.step3ExtractFeatures,
  }),
  createStepConfig<Step4PredictResponse>({
    id: 4,
    title: 'ML Prediction',
    ResultComponent: Step4PredictResults,
    mutation: api.step4Predict,
  }),
] as const

export const WINDOW_MINUTES = 10
